$.fn.setupAutoComplete = function () {
    /// <summary>Adds auto complete functionality to an input element</summary>
    /// <returns type="jQuery">Returns the jQuery element(s)</returns>

    this.each(function () {
        var tbox = $(this);
        if(tbox.attr('readonly')) return;
        var options = cafm.ac.getOptions(tbox);
        var parent = tbox.closestField();
        var acRes = $('.acRes', parent);
        if (!acRes.length) {
            acRes = $('<div>', {
                'class': 'acRes'
            }).appendTo(parent);
            tbox.data('acRes', acRes);
            // bind textbox events
            cafm.ac.bindTextBoxEvents(acRes, tbox, options);
        }
        else {
            // already initialised
            return;
        }

        // CFM-619 - fix auto complete issues - prevent browser autofill from interfering with lookup result selection and input
        tbox.ensureDisabledAutoComplete();
        
        if (tbox.isLocalityLookup()) {

            var reqLocType = tbox.data('requiredlocalitytype');
            if (reqLocType) {
                tbox.setAutoCompleteFilter('LocalityType', reqLocType);
            }
            else {
                parent.find('.locality-type-filter-btn').kendoTooltip({
                    autoHide: false,
                    showOn: 'click',
                    width: 150,
                    content: function (e) {

                        return $($('<div>').append(parent.find('.locality-type-filter')).html()).show();
                    },
                    show: function (e) {

                        var el = e.sender.popup.element;
                        if (!el.data('formPrepared')) {

                            el.find('input[type=checkbox]').click(function (evArgs) {

                                if ($(evArgs.currentTarget).isCheckboxDisabled()) return false;

                                var lt = 128; // always include company
                                el.find('input[type=checkbox]').each(function (i, chk) {

                                    chk = $(chk);
                                    if (chk.isChecked()) {

                                        lt += chk.data('value');
                                    }
                                });

                                var tbox = e.sender.element.closestField().find('.' + cafm.res.consts.CssClass_LookupInput).setAutoCompleteFilter('LocalityType', lt);

                                if (acRes.is(':visible')) cafm.ac.populateAutoCompleteItems(acRes, tbox, 1);
                            });

                            el.data('formPrepared', true);
                        }
                    }
                });

                var lt;
                switch (cafm.getCurrentModule()) {
                    case cafm.enums.CAFMModuleEnum.Helpdesk:
                        lt = cafm.res.consts.Var_HelpdeskAutoCompleteLocalityTypeDefault;
                        break;
                    case cafm.enums.CAFMModuleEnum.Property:
                        switch (cafm.nav.navigatable) {
                            case cafm.enums.Navigatable.PropertyBuildingSearch:
                                lt = cafm.res.consts.Var_BuildingSearchAutoCompleteLocalityTypeDefault;
                                break;
                            case cafm.enums.Navigatable.PropertyFloorSearch:
                                lt = cafm.res.consts.Var_FloorSearchAutoCompleteLocalityTypeDefault;
                                break;
                            case cafm.enums.Navigatable.PropertyZoneSearch:
                                lt = cafm.res.consts.Var_ZoneSearchAutoCompleteLocalityTypeDefault;
                                break;
                            case cafm.enums.Navigatable.PropertySpaceSearch:
                                lt = cafm.res.consts.Var_SpaceSearchAutoCompleteLocalityTypeDefault;
                                break;
                        }
                        break;
                    default:
                        lt = cafm.res.consts.Var_AutoCompleteLocalityTypeDefault;
                        break;
                }
                tbox.setAutoCompleteFilter('LocalityType', lt);
            }
        }
    });
    return this;
}
$.fn.setAutoCompleteFilter = function (fieldName, fieldValue) {
    /// <summary>Sets an auto complete filter for the field</summary>
    /// <param name="fieldName" type="String">The filter field name</param>
    /// <param name="fieldValue" type="String">The filter field value</param>
    /// <returns type="$">Returns the jQuery element(s)</returns>

    this.each(function () {

        // get the text box jquery object
        var tbox = $(this);

        // safe parse the options in case this isn't an element with auto complete options
        var opts = JSON.safeParse(tbox.attr('data-autocomplete'));

        // return if no valid options where retrieved
        if (!opts || !opts.Options) return;

        // create filters array if necessary
        if (!opts.Options.Filters) opts.Options.Filters = [];

        // check for existing filter with field name
        var filter = cafm.util.find(opts.Options.Filters, function (f) { return f.FieldName == fieldName; });

        // create filter if not existing
        if (!filter) {

            filter = {};
            opts.Options.Filters.push(filter);
        }

        // set field name and value
        filter.FieldName = fieldName;
        filter.FieldValue = fieldValue;

        // serialise options back onto element
        tbox.attr('data-autocomplete', JSON.stringify(opts));
    });

    return this;
}
$.fn.removeAutoCompleteFilter = function (fieldName, fieldValue) {
    /// <summary>Removes an auto complete filter for the field</summary>
    /// <param name="fieldName" type="String">The filter field name</param>
    /// <returns type="$">Returns the jQuery element(s)</returns>

    this.each(function () {

        // get the text box jquery object
        var tbox = $(this);

        // safe parse the options in case this isn't an element with auto complete options
        var opts = JSON.safeParse(tbox.attr('data-autocomplete'));

        // return if no valid options where retrieved
        if (!opts || !opts.Options || !opts.Options.Filters) return;

        // check for existing filter with field name
        var filter = cafm.util.removeWhere(opts.Options.Filters, function (f) { return f.FieldName == fieldName; });
                
        // serialise options back onto element
        tbox.attr('data-autocomplete', JSON.stringify(opts));
    });
}
$.fn.setAutoCompleteLocation = function (v) {
    /// <summary>Sets the auto complete filter value</summary>
    /// <param name="v" type="String">The filter value</param>
    /// <returns type="jQuery">Returns the jQuery element(s)</returns>

    this.each(function () {
        var tbox = $(this);
        var opts = JSON.parse(tbox.attr('data-autocomplete'));
        opts.Options.LocationID = v;
        tbox.attr('data-autocomplete', JSON.stringify(opts));
    });
}
$.fn.getAutoCompleteItemText = function () {
    /// <summary>Gets the auto complete item text (data if present, text by default)</summary>
    /// <returns type="String">Returns the auto complete item text</returns>

    let field = this.closestField(), bypassItemData;
    if (field.isLocalityLookup() && field.find(`.${cafm.res.consts.CssClass_LookupInput}`).data('showdescription') == true) {
        return this.find('.ac-item-text').text()
    }
    else {
        return this.find('.ac-item-data').text() || this.find('.ac-item-text').text();
    }
}
/// <summary name='cafm.ac' type='Object'>CAFM AutoComplete container object</summary>
cafm.ac = {
    /// <field name='searchTimeout' type='Integer'>Timeout between keypress and search</field>
    searchTimeout: 250,
    onDataRetrieved: function (resp, acRes, tbox, options) {
        /// <summary>Called when the auto complete data results have been retrieved from the server</summary>
        /// <param name="resp" type="String">The auto complete data</param>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>
        /// <param name="tbox" type="jQuery">The auto complete textbox jQuery element</param>
        /// <param name="options" type="Object">The auto complete options object</param>
        
        acRes.find('.ac-load').hideLoader();
        acRes.find('.acItem,.ac-msg').remove();

        if (resp && resp.Items && resp.Items.length) {

            var pageSize = options.Options.PageSize;

            $.each(resp.Items, function (i, item) {

                var id = item.Value,
                    itemRes = $('<span />', {
                        'class': 'acItem'
                    });

                itemRes.append($('<span />', {
                    'class': 'ac-item-text',
                    text: item.Description
                }))

                if (item.Data) itemRes.append($('<span />', {
                    'class': 'ac-item-data',
                    text: item.Data
                }))

                item.guid = cafm.guid.newGuid();
                itemRes.data('guid', item.guid);
                if (id) itemRes.data('id', id);

                itemRes.attr('data-i', i);
                itemRes.appendTo(acRes);
            });
            cafm.ac.bindItemEvents(acRes, tbox);
            acRes.data('acSelected', -1);
            acRes.data('items', resp.Items);
            acRes.data('options', options);
            cafm.ac.showResultPanel(acRes, tbox, options, resp.TotalRecordCount);

            if (pageSize && resp.TotalRecordCount > pageSize) {

                cafm.ac.getPagerDsData = function () {
                    return resp;
                }

                var dataSource;
                if ((dataSource = acRes.data('dataSource'))) {
                    dataSource.options.page = dataSource._page = options.Page || 1;
                }
                else {

                    dataSource = new kendo.data.DataSource({
                        page: 1,
                        pageSize: options.Options.PageSize,
                        serverPaging: true,
                        schema: {
                            data: 'Items',
                            total: 'TotalRecordCount'
                        },
                        transport: {
                            read: function (options) {
                                options.success(cafm.ac.getPagerDsData());
                            }
                        }
                    });
                }

                acRes.data('dataSource', dataSource);

                var pagerEl = acRes.find('.k-pager-wrap');
                if (!pagerEl.length) {
                    
                    $('<div>').kendoPager({
                        dataSource: dataSource,
                        serverPaging: true,
                        numeric: false,
                        messages: {
                            display: "{0} - {1} of {2}"
                        },
                        change: function (args) {

                            var tbox = acRes.closest('.cfField').find('.cfControl');
                            cafm.ac.populateAutoCompleteItems(acRes, tbox, parseInt(args.index));

                            if (isMobile) tbox.scrollToElement();
                        }
                    }).appendTo(acRes);

                    acRes.find('.k-pager-wrap').addClass('ac-pager-wrap');
                }
                else {

                    pagerEl.appendTo(acRes);
                }

                dataSource.page(dataSource.options.page);
                pagerEl.show();
            }
            else {

                acRes.find('.k-pager-wrap').hide();
            }
        }
        else {
            acRes.find('.k-pager-wrap').hide();
            acRes.append('<span class="ac-msg">{0}</span>'.format(cafm.res.str.LabelAutoCompleteNoMatches));
            cafm.ac.showResultPanel(acRes, tbox, options, 0);
        }
    },
    populateAutoCompleteItems: function (acRes, tbox, page) {
        /// <summary>Called when the auto complete requires population</summary>
        /// <param name="acRes" type="$">The auto complete result jQuery element</param>
        /// <param name="tbox" type="$">The auto complete textbox jQuery element</param>
        /// <param name="page" type="Number">The current page of results to view (optional and defaults to 1)</param>

        let options = cafm.ac.getOptions(tbox),
            action = cafm.ac.getDataAction(),
            associateId = tbox.data('associateid'),
            allowDuplicates = tbox.data('allowduplicates'),
            idField = tbox.data('associateidfield'),
            val = tbox.val();

        // asign ac ID if not already set
        if (!tbox.data('acid')) tbox.data('acid', cafm.guid.newGuid());

        if (options.Options.MinCharacters && val.length < options.Options.MinCharacters) {

            acRes.find('.ac-load').hideLoader();
            acRes.children('.acItem,.ac-msg').remove();
            acRes.find('.k-pager-wrap').hide();
            acRes.append('<span class="ac-msg">{0}</span>'.format(cafm.res.str.TemplateEnterAtLeast0CharactersToSearch.format(options.Options.MinCharacters)));
            cafm.ac.showResultPanel(acRes, tbox, options, 0);
            return;
        }
        else if (isUndefined(page)) {

            acRes.children('.ac-load,.inplace-loader,.ac-msg,.acItem').remove();
            acRes.find('.k-pager-wrap').hide();
            acRes.find('.ac-close').hide();
            acRes.append('<div class="ac-load"></div>');
        }
        else {

            acRes.children('.ac-load').remove();
            acRes.find('.k-pager-wrap').append('<div class="ac-load"></div>');
        }
        
        // check for associate list and allow duplicates flag
        if (associateId && idField && allowDuplicates === false) {

            // pre data source read handler function
            action.set('beforeSend', r => {
                // set exlude IDs header on request
                cafm.web.funcs.setRequestExcludeIds({
                    dataSource: $('#' + associateId).getLv().dataSource,
                    idField: idField,
                    request: r
                });
            });
        }

        var isLocality = tbox.isLocalityLookup();
        if (options.Options.MaxFetchCount < 1) {

            options.Options.MaxFetchCount = isMobile ? (isLocality ? cafm.res.consts.Var_MobileLocalityAutoCompletePageSize : cafm.res.consts.Var_MobileAutoCompletePageSize) : (isLocality ? cafm.res.consts.Var_LocalityAutoCompletePageSize : cafm.res.consts.Var_AutoCompletePageSize);
        }

        if (page) {

            options.Page = page;
        }
        
        // is paged and is mobile, paging should be preconfigured on the field...
        if (options.Options.PageSize && isMobile) {

            options.Options.PageSize = tbox.isLocalityLookup() ? cafm.res.consts.Var_MobileLocalityAutoCompletePageSize : cafm.res.consts.Var_MobileAutoCompletePageSize;
        }

        if (!cafm.util.hasStringVal(tbox.val())) return;

        options.SearchString = tbox.val();

        var guid = cafm.guid.newGuid();
        acRes.data('guid', guid);

        if (isLocality) {
            let requiresBookableRooms = tbox.data('requirebookablerooms');
            if (requiresBookableRooms) {
                options.RequireBookableRooms = requiresBookableRooms;
            }
        }

        action.set({
            type: options.Type,
            values: options,
            statusCodeFuncs: {
                200: function (d) {

                    if (guid == acRes.data('guid'))
                        cafm.ac.onDataRetrieved(d, acRes, tbox, options);
                }
            }
        });

        if (cafm.ac.timeout) clearTimeout(cafm.ac.timeout);
        cafm.ac.timeout = setTimeout(function () {
            action.loaderTarget = acRes.find('.ac-load');
            action.execute();
            delete cafm.ac.timeout;
        }, cafm.ac.searchTimeout);
    },
    showResultPanel: function (acRes, tbox, options, count) {
        /// <summary>Displays the auto complete results</summary>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>
        /// <param name="tbox" type="jQuery">The auto complete textbox jQuery element</param>
        /// <param name="options" type="Object">The auto complete options object</param>
        /// <param name="count" type="Number">The number of results</param>

        var bEl = tbox.hasClass(cafm.res.consts.CssClass_LookupInput) ? tbox.parent() : tbox;
        
        if (options.ResultsCssClass) {
            if (count)
                acRes.addClass(options.ResultsCssClass);
            else
                acRes.removeClass(options.ResultsCssClass);
        }

        if (!acRes.find('.ac-close').length) {

            acRes.append($('<button>', {
                'class': 'ac-close',
                'text': cafm.res.consts.TextClose,
                'click': function () {
                    cafm.ac.hideAutoCompleteItems(acRes, tbox);
                    cafm.util.doWhen(cafm.ac.cleanTextFunc, function () { return isFunc(cafm.ac.cleanTextFunc) }, 4, 250);
                    cafm.util.doWhen(cafm.ac.cleanTextFunc2, function () { return isFunc(cafm.ac.cleanTextFunc2) }, 4, 250);
                }
            }))
        }

        if (tbox.isLocalityLookup()) {
            acRes.addClass('locality-text-search-res');
        }
        
        acRes
            .css('top', bEl.position().top + tbox.outerHeight() + 3)
            .css('left', bEl.position().left)
            .width(bEl.width()-2)
            .slideDown(250, function () {
                acRes.find('.ac-close').show();
                return false;
            });
    },
    hideAutoCompleteItems: function (acRes, tbox) {
        /// <summary>Hides the auto complete results</summary>
        acRes.slideUp(250, function () {
            acRes.children().remove();
        });
    },
    bindTextBoxEvents: function (acRes, tbox, options) {
        /// <summary>Bind the required DOM events to the auto complete textbox</summary>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>
        /// <param name="tbox" type="jQuery">The auto complete textbox jQuery element</param>
        /// <param name="options" type="Object">The auto complete options object</param>

        tbox.enterPressed(function (e) {
            
            var itemRes = cafm.ac.getHoveredItem(acRes);

            if (itemRes) {

                cafm.ac.selectAutoCompleteItem(acRes, tbox, true);
                cafm.ac.hideAutoCompleteItems(acRes, tbox);
                tbox.data('enterPressed', true);
            }

            tbox.blur();
            return false;
        });
        tbox.off('input.ac').on('input.ac', function (e) {

            if (!tbox.data('acActive')) return;

            var kp = e.keyCode ? e.keyCode : e.charCode;
            if (!tbox.val()) {

                cafm.ac.hideAutoCompleteItems(acRes, tbox);
                return;
            }
            else if ([9, 16, 17, 20, 32, 37, 38, 39, 40].indexOf(kp) > -1) return;
            else {
                cafm.ac.populateAutoCompleteItems(acRes, tbox);
            }
            body.off('focus.ac2').on('focus.ac2', 'input, select, textarea', function (e) {
                
                var t = $(e.currentTarget);
                if (t.hasClass('locality-type-checkbox')) {
                    return false;
                }

                var acId = $(e.target).data('acid');
                if (!acId || acId != tbox.data('acid')) {

                    cafm.util.callFunction(cafm.ac.cleanTextFunc);
                    cafm.util.callFunction(cafm.ac.cleanTextFunc2);
                    body.off('focus.ac2', 'input, select, textarea');
                }
            });
        });

        if(!(isMobile && isTouch))
            tbox.off('keyup.ac').on('keyup.ac', function (e) {
            
                var kp = e.keyCode ? e.keyCode : e.charCode;
                if ([9, 16, 17, 20, 32, 37, 39].indexOf(kp) > -1) return;
                else if (kp == 27)
                    cafm.ac.hideAutoCompleteItems(acRes, tbox);
                else if (tbox.val().length) {
                    if (kp == 38 || kp == 40) {
                        cafm.ac.navigateAutoCompleteItems(acRes, kp);
                    }
                    else if (kp != 13) {
                        cafm.ac.populateAutoCompleteItems(acRes, tbox);
                    }
                }
            });

        tbox.off('focus.ac').on('focus.ac', function (e) {

            tbox.data('acActive', true);

            if (tbox.data('localityid')) {
                tbox.setAutoCompleteLocation(tbox.data('localityid'));
            }

            if (tbox.isLocalityLookup() && !tbox.data('selectedText') && tbox.val())
                tbox.data('selectedText', tbox.val());

            if (!acRes.is(':visible') && tbox.attr('type') != 'email') {
                cafm.util.callFunctionAsync({ func: function () { tbox[0].setSelectionRange(0, tbox[0].value.length); }, timeout: 100 });
            }
        });

        tbox.off('blur.ac').on('blur.ac', function (e) {

            cafm.util.callFunctionAsync({ func: () => tbox.removeData('acActive'), timeout: 300 });
        });

        if (!options.Options.DistinctWithNoIdentifier) {

            tbox.off('change.ac').on('change.ac', function (e) {

                if (cafm.util.isTrue(tbox.data('acActive'))) {
                    
                    cafm.ac.cleanTextFunc = function () {

                        var ep = tbox.data('enterPressed');
                        if (!ep) {
                            var v = tbox.val();
                            var autoChange;
                            if (v) {

                                var matched = false;
                                $.each(acRes.children('.acItem'), function (i, c) {
                                    c = $(c);
                                    if (c.getAutoCompleteItemText().toLowerCase() == v.toLowerCase()) {
                                        cafm.ac.hoverAutoCompleteItem(acRes, c);
                                        cafm.ac.selectAutoCompleteItem(acRes, tbox, true);
                                        matched = true;
                                        return false;
                                    }
                                });

                                if (!matched && !tbox.data('allowcustomtext')) {

                                    tbox.val(tbox.data('selectedText') || '');
                                    cafm.ac.hideAutoCompleteItems(acRes, tbox);
                                    autoChange = tbox.data('autocompletechange');
                                    if (autoChange) {
                                        cafm.handlers.exe(autoChange, { source: tbox, target: tbox, val: '', matched: matched });
                                    }
                                }
                                else if (!matched && tbox.data('allowcustomtext')) {
                                    
                                    cafm.ac.hideAutoCompleteItems(acRes, tbox);
                                    autoChange = tbox.data('autocompletechange');
                                    if (autoChange) {
                                        cafm.handlers.exe(autoChange, { source: tbox, target: tbox, val: v, matched: matched });
                                    }
                                }
                            }
                            else {

                                if (tbox.isLocalityLookup() && tbox.data('selectedText')) {

                                    tbox.val(tbox.data('selectedText'));
                                }

                                autoChange = tbox.data('autocompletechange');
                                if (autoChange) {
                                    cafm.handlers.exe(autoChange, { source: tbox, target: tbox, val: '' });
                                }

                                cafm.ac.hideAutoCompleteItems(acRes, tbox);
                            }
                        }
                        else {
                            tbox.removeData('enterPressed');
                        }

                        delete cafm.ac.cleanTextFunc;
                    };             
                    
                    if (!tbox.val() || !acRes.children('.acItem').length)
                        cafm.util.callFunction(cafm.ac.cleanTextFunc);
                }
            });
        }
        else {

            tbox.off('change.ac').on('change.ac', function (e) {

                var v = tbox.val();
                var matched = false;
                $.each(acRes.children(), function (i, c) {
                    c = $(c);
                    if (c.getAutoCompleteItemText().toLowerCase() == v.toLowerCase()) {
                        cafm.ac.hoverAutoCompleteItem(acRes, c);
                        cafm.ac.selectAutoCompleteItem(acRes, tbox, true);
                        matched = true;
                        return false;
                    }
                });

                var autoChange = tbox.data('autocompletechange');
                if (autoChange) {
                    var v = tbox.val();
                    cafm.handlers.exe(autoChange, { source: tbox, target: tbox, val: v, matched: matched });
                }

                cafm.ac.cleanTextFunc2 = function () {
                    cafm.ac.hideAutoCompleteItems(acRes, tbox);
                    delete cafm.ac.cleanTextFunc2;
                }
            });
        }
    },
    bindItemEvents: function (acRes, tbox, options) {
        /// <summary>Binds required DOM events to the auto complete results</summary>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>
        /// <param name="tbox" type="jQuery">The auto complete textbox jQuery element</param>
        /// <param name="options" type="Object">The auto complete options object</param>
        
        $('.acItem', acRes).off('mouseenter.ac').on('mouseenter.ac', function () {

            cafm.ac.hoverAutoCompleteItem(acRes, $(this));
        }).off('mouseleave.ac').on('mouseleave.ac', function () {
            cafm.ac.unHoverAutoComplete(acRes);
        });
        acRes.off('click.ac').on('click.ac', '.acItem', function (e) {
            var t = $(e.currentTarget);
            if (t.hasClass('k-pager-wrap') || t.hasClass('k-pager-nav') || t.hasClass('k-icon') || t.hasClass('k-pager-info')) {
                return false;
            }
            cafm.ac.hoverAutoCompleteItem(acRes, t);
            cafm.ac.selectAutoCompleteItem(acRes, tbox, true);
            return false;
        });

        if (tbox.isLocalityLookup()) {

            body.on('click.ac', '.openLookup', function (e) {

                cafm.util.callFunction(cafm.ac.cleanTextFunc);
                body.off('click.ac', '.openLookup');
            });
            body.on('click.ac2', '.clearLookup', function (e) {

                cafm.ac.hideAutoCompleteItems(acRes, tbox);
                body.off('click.ac2', '.clearLookup');
            });
        }
    },
    navigateAutoCompleteItems: function (acRes, kp) {
        /// <summary>Navigates the auto complete results using the up and down arrow keys</summary>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>
        /// <param name="kp" type="Integer">The key code for the keyboard key that was pressed</param>

        var selIndex = isDefined(acRes.data('acSelected')) ? acRes.data('acSelected') : -1;
        var len = acRes.children('.acItem').length;
        if (kp == 40) selIndex++;
        if (kp == 38) selIndex--;
        if (selIndex >= len) selIndex = 0;
        if (selIndex < 0) selIndex = len - 1;
        if (len) {
            acRes.data('acSelected', selIndex);
            cafm.ac.hoverAutoCompleteItem(acRes, cafm.ac.getHoveredItem(acRes));
        }
    },
    selectAutoCompleteItem: function (acRes, tbox, blur) {
        /// <summary>Selects the current navigated auto complete result item (navigated=Keyboard up/down + enter OR Click OR Manual text entry + enter/blur)</summary>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>
        /// <param name="tbox" type="jQuery">The auto complete textbox jQuery element</param>
        /// <param name="blur" type="Boolean">Flag telling the method whether or not to blur the textbox once completed</param>

        function hideResults() {
            
            acRes.slideUp(function () {

                tbox.removeData('selecting');
                acRes.hide();
                acRes.children().remove();
            });
        }

        if (tbox.data('selecting')) {

            hideResults();
            return;
        }
        else {

            tbox.data('selecting', true);

            var options = cafm.ac.getOptions(tbox);
            var itemRes = cafm.ac.getHoveredItem(acRes);
            if (itemRes) {

                var txt = itemRes.getAutoCompleteItemText();
                if (!options.Options.DistinctWithNoIdentifier) {

                    var id = itemRes.data('id');
                    tbox.data('id', id);

                    // handle lookups
                    if (tbox.isLookup()) {
                        
                        tbox.data('selectedText', tbox.val());

                        // if the lookup is a hierarchy integrated locality lookup...
                        if (tbox.data('integrate')) {

                            // get the full locality object so we can set the locality in the standard way...
                            cafm.actions.getResponseObject({
                                url: cafm.url.api('locality/getdescription/{0}', id),
                                requestDelay: 0,
                                callback: function (locality) {

                                    if (isMobile) {

                                        cafm.hi.localityChanged(locality);
                                    }
                                    else {

                                        cafm.hi.setCurrentLocality({
                                            locality: locality
                                        });
                                    }
                                }
                            })
                        }

                        cafm.lookup.setLookup({
                            lookup: tbox.closest('.cfLookup'), 
                            value: id, 
                            text: txt
                        });
                    }
                    else {
                        tbox.changeVal(txt);
                    }
                }
                else {

                    tbox.val(txt);
                    tbox.trigger('change');
                }

                var onselect = tbox.data('autocompleteselect');
                cafm.util.callFunction(onselect, itemRes);
            }

            hideResults();
            body.off('focus.ac2', 'input, select, textarea');
            delete cafm.ac.cleanTextFunc;
            delete cafm.ac.cleanTextFunc2;
        }
    },
    hoverAutoCompleteItem: function (acRes, itemRes) {
        /// <summary>Called when navigating over an auto complete result item</summary>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>
        /// <param name="itemRes" type="jQuery">The auto complete result item jQuery element</param>

        cafm.ac.unHoverAutoComplete(acRes);
        itemRes.addClass('acHov');
        acRes.data('acSelected', itemRes.closest('.acItem').data('i'));
    },
    unHoverAutoComplete: function (acRes) {
        /// <summary>Called when moving away from an auto complete result item</summary>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>

        acRes.children().removeClass('acHov');
        acRes.removeData('acSelected');
    },
    getHoveredItem: function (acRes) {
        /// <summary>Gets the jQuery element for the currently navigated auto complete result item, or undefined if none are currently navigated</summary>
        /// <param name="acRes" type="jQuery">The auto complete result jQuery element</param>
        /// <returns type="jQuery">Returns the currently navigated auto complete result item jQuery element</returns>

        var selIndex = acRes.data('acSelected');
        var hov;
        $.each(acRes.children('.acItem'), function (i, c) {
            if (i == selIndex) {
                hov = $(c);
            }
        });
        return hov;
    },
    getOptions: function (tbox) {
        /// <summary>Gets the parsed JSON auto complete options from the data-autocomplete attribute for the element</summary>
        /// <param name="tbox" type="jQuery">The auto complete textbox jQuery element</param>
        /// <returns type="Object">The parsed JSON auto complete options object</returns>

        var s = tbox.attr('data-autocomplete');
        return JSON.parse(s);
    },
    /// <field name='getDataAction' type='cafm.actions.Action'>The getDataAction autocomplete action is used to query the auto complete server api</field>
    getDataAction: () => {
        
        return new cafm.actions.Action({
            id: 'getAutoCompleteData',
            method: 'POST',
            url: action => {
                let actionName, controllerName;
                switch (action.type) {
                    case cafm.enums.ModelKey.EquipmentRequestItem:
                        actionName = 'SearchEquipmentAssets'
                        break;
                    case cafm.enums.ModelKey.LocalityInfo:
                        controllerName = 'Locality';
                        actionName = 'TextSearch'
                        break;
                    default:
                        controllerName = 'AutoComplete';
                        actionName = 'Search'
                        break;
                }
                if (!controllerName) controllerName = 'AutoComplete';
                return cafm.url.api(`${controllerName}/${actionName}`);
            },
            requestDelay: 0,
            exeDiffAllowance: 225,
            usesInPlaceLoader: true
        });
    }
}